/* global axios */
import ApiClient from '../ApiClient';

class PilotKnowledgeBases extends ApiClient {
  constructor() {
    super('pilot/knowledge_bases', { accountScoped: true });
  }

  get({ page = 1, search, sort, sortOrder } = {}) {
    const params = { page };
    if (search) params.search = search;
    if (sort) params.sort = sort;
    if (sortOrder) params.sortOrder = sortOrder;
    return axios.get(this.url, { params });
  }

  show(id, { page = 1, search, sort, payload } = {}) {
    const params = { page };
    if (search) params.search = search;
    if (sort) params.sort = sort;

    // 如果有 payload 参数，使用 POST 请求发送到 filter_documents 端点
    if (payload) {
      return axios.post(`${this.url}/${id}/filter_documents`, {
        page,
        search,
        sort,
        payload,
      });
    }

    return axios.get(`${this.url}/${id}`, { params });
  }

  // 新增：筛选文档
  filterDocuments(id, { page, search, sort, payload }) {
    return axios.post(`${this.url}/${id}/filter_documents`, {
      page,
      search,
      sort,
      payload,
    });
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'created_at', queryPayload, search) {
    let requestURL = `${this.url}/filter?page=${page}`;
    if (sortAttr) {
      requestURL += `&sort=${sortAttr}`;
    }
    if (search) {
      requestURL += `&search=${encodeURIComponent(search)}`;
    }
    return axios.post(requestURL, queryPayload);
  }

  create(data = {}) {
    // 如果是FormData，直接发送；否则包装在knowledge_base对象中
    if (data instanceof FormData) {
      return axios.post(this.url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.post(this.url, {
      knowledge_base: data,
    });
  }

  update(id, data = {}) {
    // 如果是FormData，直接发送；否则包装在knowledge_base对象中
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.patch(`${this.url}/${id}`, {
      knowledge_base: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  recallTest(id, params) {
    return axios.post(`${this.url}/${id}/recall_test`, params);
  }

  getRecallTestHistories(id, params = {}) {
    return axios.get(`${this.url}/${id}/recall_test_histories`, { params });
  }

  clearRecallTestHistories(id) {
    return axios.delete(`${this.url}/${id}/clear_recall_test_histories`);
  }
}

export default new PilotKnowledgeBases();
